import { useEffect } from 'react';

// Referenzzähler, damit verschachtelte Modale den Scroll-Lock nicht vorzeitig lösen.
let lockCount = 0;
let previousOverflow = '';

/**
 * Sperrt das Scrollen des <body>, solange `active` true ist. Unterstützt
 * verschachtelte Dialoge über einen gemeinsamen Referenzzähler.
 */
export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return;

    if (lockCount === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount === 0) {
        document.body.style.overflow = previousOverflow;
      }
    };
  }, [active]);
}
